import { render } from "./BackOffice.vue?vue&type=template&id=6409c364"
import script from "./BackOffice.vue?vue&type=script&lang=js"
export * from "./BackOffice.vue?vue&type=script&lang=js"
script.render = render

export default script